import React from 'react';
import { CardType } from '../../types/api/card';
import { ROUTES } from '../../constants/clientRoutes';
import ActionLink from '../../components/Common/ActionLink';
import { FEATURE_FLAGS } from '../../constants/featureFlags';
import { trackEvent } from '../../services/eventTracker';
import { EVENTS } from '../../constants/events';
import { useDispatch } from "react-redux";
import { SetDisplayODTModal } from "../../actions/card";
import i18n from '../../i18n/config';
import { Link, useHistory } from 'react-router-dom';

const Balance = ({ card, featureFlags }: { card: CardType; featureFlags: string[] }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClick = async () => {
    trackEvent(EVENTS.ODT.BANK_TRANSFER_STARTED);

    if (card.availability.isODTUnavailable) {
      dispatch(SetDisplayODTModal(true));
    } else {
      history.push(ROUTES.ODT.BANK_ACCOUNT_SELECTION);
    }
  }

  return (
    <section className="dashboard-banner text-center">
      <div className="mb-24">
        {card.status !== "Loading" &&
          <p className="card-balance mb-0">{card.balanceString || "Unavailable"}</p>
        }
        <h2 className="mb-0">{i18n.t("PAGES.DASHBOARD.AVAILABLE_BALANCE")}</h2>
      </div>

      <div className="call-to-action">
        {featureFlags.includes(FEATURE_FLAGS.SEND_TO_BANK_ACCOUNT) &&
          <ActionLink
            text="Send to Bank"
            classes="btn btn-tertiary bold"
            clickFunc={handleClick}
            dataCy="send-to-bank-button"
          />
        }

        {featureFlags.includes(FEATURE_FLAGS.DISPLAY_CASH_PICKUP) &&
          <Link to={ROUTES.MONEY_TRANSFER} className="btn btn-tertiary bold" data-cy="cash-pickup-button">
            Cash Pickup
          </Link>
        }

      </div>
    </section>
  );
}

export default Balance;